/**
 * Shows/hides a confirmation modal with a title, message, cancel and confirmation action
 */
var VRC = VRC || {};

VRC.ConfirmationModal = (function () {
	var $modal;
	var _template = WELL.Handlebars.VRC.confirmation_modal;
	var TYPES = {
		CONFIRMATION: 'confirmation',
		INFO: 'info'
	};

	var _defaults = {
		type: TYPES.CONFIRMATION,
		onCancel: function () {
		},
		onConfirm: function () {
		},
		msg: '',
		title: 'Warning'
	};

	var hide = function () {
		$modal = $('#modal');
		$modal.modal('hide');
	};

	/**
	 * Us
	 * @param options see _defaults for available parameters.
	 */
	var show = function (options) {
		options = $.extend(_defaults, options);
		$modal = $('#modal');
		$modal.html(_template(options));
		attachEvents(options);
		$modal.filter('.modal').modal();

	};

	var attachEvents = function (options) {
		var $confirmBtn = $modal.find('.confirmation__ok-btn');
		var $cancelBtn = $modal.find('.confirmation__cancel-btn');
		$confirmBtn.unbind('click').bind('click', function (e) {
			options.onConfirm(e);
			hide()
		});
		$cancelBtn.unbind('click').bind('click', function (e) {
			options.onCancel(e);
			hide()
		});
	};

	return {
		show: show,
		hide: hide,
		TYPES: TYPES
	}
})();
